import DateRangeReport from "../../../../../components/DateRangeReport";
import InputFactory from "../../../../../components/InputFactory";
import Search from "../../../../../components/Search";
// import filterFields from "../filterFields.json";

function Filters({
  schemas,
  searchName,
  searchSubmit,
  onSearchStatus,
  onChangeDate,
  schema,
}) {
  const _onSearchStatus = (value, field) => {
    if (value) {
      const query = { $or: [{ [field]: value }] };
      onSearchStatus(query);
      return;
    }

    onSearchStatus({});
  };

  // console.log("schemas", schemas);

  const filterFields = {
    no_record_requested: {
      type: "String",
      objectField: "firstName",
    },
    record_requested: {
      type: "String",
      objectField: "fullName",
    },
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row gap-2">
        <div className="col-12 col-md-4">
          <Search
            schemas={schemas}
            onSubmit={searchName}
            fields={schema.fields}
            placeholder={"Search Name"}
            searchIcon
          />
        </div>
        <div className="col-12 col-md-2">
          {/* <Search
            schemas={schemas}
            onSubmit={searchSubmit}
            fields={{ status: { type: "String" } }}
            placeholder={"Search Status"}
          /> */}
          <InputFactory
            type="Enum"
            options={["Request for Access", "Request Granted"]}
            placeholder={"Select Status"}
            field={"status"}
            onChange={_onSearchStatus}
          />
        </div>
        <div className="col-12 col-md-2">
          <Search
            schemas={schemas}
            onSubmit={searchSubmit}
            fields={{ request_number: { type: "Number" } }}
            placeholder={"Search Request Number"}
          />
        </div>
        <div className="col-12 col-md-2">
          <DateRangeReport onChange={onChangeDate} field="createdAt" />
        </div>
      </div>
    </>
  );
}

export default Filters;
